import Icon from '../components/Icon.vue'

Icon.register({
  rocket: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505.1 19.1c7 32.2 7 57.4 6.9 82.6 0 102.7-55.4 164.8-128 211.1v104.4 0c0 16.4-11.9 35.6-26.5 42.9l-98.7 49.4c-2.8 1.4-7.6 2.5-10.7 2.5-13.2 0-24-10.8-24-24v0-103.8l-22.5 22.5c-5.2 5.2-15.3 9.4-22.6 9.4-7.3 0-17.5-4.2-22.6-9.4l-50.9-50.9c-5.2-5.2-9.4-15.3-9.4-22.6s4.2-17.5 9.4-22.6l22.5-22.5h-103.8 0c-13.2 0-24-10.8-24-24 0-3.1 1.1-7.9 2.5-10.7l49.4-98.8c7.3-14.6 26.5-26.5 42.9-26.5h104.2c46.2-72.8 108.1-128 211.3-128 25.1 0 50.3 0 82.5 6.9 5.5 1.2 11 6.7 12.2 12.2zM384 168c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rocket.js
// module id = 1845
// module chunks = 0